import React, { Component, Fragment } from 'react';
import './common.less';
import './androidPage.less';
import Toast from './toast';
import { isWeiXin } from '../static/js/util/env';
import axios from 'axios';
import { setOpenInBrowserFalse, getErrorShowAction, getErrorTextAction } from '../store/actionCreators';
import { connect } from 'react-redux';
import classNames from "classnames";

const AndroidPage = (props) => {
  return (
    <Fragment>
      <div className="content-wrapper android-wrapper">
        <div className="logo-wrapper">
          <div className="logo"></div>
          <div className="title">果加智能</div>
        </div>
        <div className="button-wrapper">
          <div className={classNames({"notice-text": true,"hide": !isWeiXin})}>
            <div className="text">微信内无法下载APP,请点击右上角选择“浏览器打开”</div>
          </div>
          <div className="link-button" onClick={props.downLoad}>
            <div className="button-icon"/>
            <div className="text">Android版下载</div>
          </div>
        </div>
      </div>
      <div className={classNames({"popup-wrapper": true,"hide": props.openInBrowser})}>
        <div className="popup-text">请点击右上角选择 “浏览器打开”</div>
      </div>
      <Toast show={props.errorShow} content={props.errorText}/>
    </Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    openInBrowser: state.openInBrowser,
    errorShow: state.errorShow,
    errorText: state.errorText
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    downLoad() {
      if (isWeiXin) {
        const action = setOpenInBrowserFalse()
        dispatch(action)
      } else {
        if (!window.navigator.onLine) {
          dispatch(getErrorTextAction('网络异常，请稍后再试'))
          dispatch(getErrorShowAction(true))
          setTimeout(() => {
            dispatch(getErrorShowAction(false))
          }, 3000)
          return;
        }
        axios.post('/download/system/app/newest_version', {})
          .then(function (response) {
            window.location.href = response.data.data.url;
          })
          .catch(function (error) {
            dispatch(getErrorTextAction('服务器异常，请稍后再试'))
            dispatch(getErrorShowAction(true))
            setTimeout(() => {
              dispatch(getErrorShowAction(false))
            }, 2000)
          })
      }
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AndroidPage)